import { h, render } from 'preact'; /** @jsx h */

import OrderConfirmationPage from './pages/orderConfirmationPage';
import ProductsPage from './pages/productsPage';
import ShoppingCartPage from './pages/shoppingCartPage';

import { NotificationProvider } from './context/NotificationContext';
import './styles/style.scss';

const body = document.body;
const container = document.getElementById('webshop');
const urlPath = window.location.pathname;
const slug = urlPath.split('/')[2];

let pageComponent;

switch (urlPath) {
    case '/nettbutikk/':
        pageComponent = (
            <NotificationProvider>
                <ProductsPage />
            </NotificationProvider>
        );
        break;
    case '/nettbutikk/handlevogn/':
        pageComponent = (
            <NotificationProvider>
                <ShoppingCartPage slug="handlevogn" />
            </NotificationProvider>
        );
        break;
    case '/nettbutikk/ordrebekreftelse/':
        pageComponent = (
            <NotificationProvider>
                <OrderConfirmationPage slug="ordrebekreftelse" />
            </NotificationProvider>
        );
        break;
    default:
        pageComponent = (
            <NotificationProvider>
                <ProductsPage slug={slug} />
            </NotificationProvider>
        );
        break;
}

render(<div id="webshop">{pageComponent}</div>, body, container);
